import { Box, Button, IconButton, Paper, Typography } from '@mui/material'
import Excelimg from "../../assets/images/excel.png";
import { PublicClientApplication } from "@azure/msal-browser";
import React, { useEffect, useState } from 'react'
import ResultUploadPopup from '../../components/Reusable/ResultDashboard/ResultUploadPopup';
import { useMsal } from '@azure/msal-react';
import { apiService } from '../../api/apiService';
import FullPageLoader from '../../components/Reusable/Loaders/FullPageLoader';
import Trash from "../../assets/SVGs/trash_icon.svg";
import DeleteConfirmationDialog from '../../components/Reusable/FinalStatusRefactor/DeleteConfirmationDialog';


const DashboardSelect = ({
    label,
    id,
    options,
    defaultValue,
    onChange,
}: {
    label: string;
    id: string;
    options: string[];
    defaultValue?: string;
    onChange: (value: string) => void;
}) => (
    <Box>
        <label htmlFor={id}>{label}</label>
        <br />
        <select
            id={id}
            className="selectDashboardoption"
            defaultValue={defaultValue}
            onChange={(e) => onChange(e.target.value)}
        >
            {options.map((option, idx) => (
                <option key={idx} value={option}>
                    {option}
                </option>
            ))}
        </select>
    </Box>
);

const UploadResult: React.FC<{ onSuccess?: () => void }> = ({ onSuccess }) => {
    const { instance } = useMsal();
    const [openUploadPopup, setOpenUploadPopup] = useState(false);
    const currentYear = new Date().getFullYear();
    const currentYearString = currentYear.toString();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [fileData, setFileData] = useState<any[]>([]);
    const [selectedYear, setSelectedYear] = useState<string>(currentYearString);
    const [selectedHalfYear, setSelectedHalfYear] = useState<string>("H1");
    const [selectedFileId, setSelectedFileId] = useState<string | number | null>(null);
    const [isUpdateMode, setIsUpdateMode] = useState(false);
    const [selectedFileYear, setSelectedFileYear] = useState<string>("");
    const [selectedFileHalfYear, setSelectedFileHalfYear] = useState<string>("");
    const [open, setOpen] = useState(false);
    const [deletingId, setDeletingId] = useState<number | null>(null);


    const years = Array.from(
        { length: Math.max(currentYear - 2025 + 1, 1) },
        (_, i) => (Math.max(2025, currentYear) - i).toString()
    );

    const halfYearlyOptions = ["H1", "H2"];


    const handleOpenUploadPopup = () => {
        setSelectedFileId(null);
        setIsUpdateMode(false);
        setSelectedFileYear("");
        setSelectedFileHalfYear("");
        setOpenUploadPopup(true);
    };

    const handleOpenUpdatePopup = (file: any) => {
        setSelectedFileId(file.id);
        setSelectedFileYear(file.year || "");
        setSelectedFileHalfYear(file.half_year || "");
        setIsUpdateMode(true);
        setOpenUploadPopup(true);
    };

    const handleCloseUploadPopup = () => {
        setOpenUploadPopup(false);
        // fetchData();
    };

    const handleUploadSuccess = () => {
        fetchData();
        if (onSuccess) {
            onSuccess();
        }
    };


    const handleYearChange = (year: string) => {
        setSelectedYear(year);
    };

    const handleHalfYearChange = (half: string) => {
        setSelectedHalfYear(half);
    };

    const fetchData = React.useCallback(async () => {
        setIsLoading(true);
        setError(null);

        try {
            const jsonResponse = await apiService(
                `/ops/filter_result_file?year=${selectedYear}&half_year=${selectedHalfYear}`,
                "GET",
                undefined,
                undefined,
                instance as PublicClientApplication
            );

            if (jsonResponse?.status === "success" && Array.isArray(jsonResponse.data)) {
                setFileData(jsonResponse.data);
            } else {
                console.warn("Unexpected format for File data:", jsonResponse);
            }
        } catch (err: any) {
            setError(err.message || "Error fetching File");
            console.error("File API Error:", err);
        } finally {
            setIsLoading(false);
        }
    }, [selectedYear, selectedHalfYear, instance]);

    useEffect(() => {
        if (selectedYear && selectedHalfYear) {
            fetchData();
        }
    }, [selectedYear, selectedHalfYear, instance, fetchData]);


    const handleClose = () => setOpen(false);
    const handleClickOpen = (id: number) => {
        setDeletingId(id);
        setOpen(true);
    };

    const handleDelete = async () => {
        if (deletingId === null) return;

        try {
            const response = await apiService(
                `/ops/result_file/${deletingId}`,
                "DELETE",
                undefined,
                undefined,
                instance as PublicClientApplication
            );

            if (response?.status === "success") {
                fetchData();
                if (onSuccess) {
                    onSuccess();
                }
            }

        } catch (error) {
            console.error("Error deleting file:", error);
            setError("Failed to delete the file. Please try again.");
        } finally {
            setDeletingId(null);
            handleClose();
        }
    };


    return (

        <>

            {isLoading && (
                <FullPageLoader />
            )}
            <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: '10px', fontSize: '18px' }}>Upload GBS Result</Typography>

            <Paper sx={{ pl: 2, pt: 3, pb: 2, pr: 2, mb: 2, mt: 2, }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'left', gap: "20px", marginBottom: '20px', width: '50%' }}>
                        <Box sx={{ width: '35%' }}>
                            <DashboardSelect
                                id="year"
                                label="Year"
                                options={years}
                                defaultValue={currentYearString}
                                onChange={handleYearChange}

                            />
                        </Box>
                        <Box sx={{ width: '35%' }}>
                            <DashboardSelect
                                id="half"
                                label="Half-yearly"
                                options={halfYearlyOptions}
                                defaultValue="H1"
                                onChange={handleHalfYearChange}

                            />
                        </Box>
                    </Box>
                    <Box>
                        <Box sx={{ display: 'flex', justifyContent: 'center', flexFlow: 'column', alignItems: 'center' }}>
                            <Button
                                variant="contained"
                                onClick={handleOpenUploadPopup}
                                sx={{
                                    backgroundColor: "linear-gradient(238deg, #D7A833 1.68%, #F4DF03 91.8%)",
                                    color: "#000",
                                    textTransform: "none",
                                    fontFamily: "Avantt",
                                    width: "130px",
                                    "&:hover": {
                                        backgroundColor: "linear-gradient(238deg, #D7A833 1.68%, #F4DF03 91.8%)",
                                    },
                                }}>
                                Upload
                            </Button>
                            {openUploadPopup &&
                                <ResultUploadPopup
                                    open={openUploadPopup}
                                    onClose={handleCloseUploadPopup}
                                    fileId={selectedFileId || undefined}
                                    initialYear={selectedFileYear}
                                    initialHalfYear={selectedFileHalfYear}
                                    isUpdate={isUpdateMode}
                                    onUploadSuccess={handleUploadSuccess}
                                />
                            }
                        </Box>
                    </Box>
                </Box>
            </Paper>

            {!isLoading && error && (
                <Paper sx={{ marginTop: '20px', padding: '10px', textAlign: 'center', }}>
                    <Typography variant="h6" sx={{ color: '#222', fontWeight: 500 }}>
                        {error}
                    </Typography>
                </Paper>
            )}

            {!isLoading && (
                fileData.length > 0 ? (
                    fileData.map((file) => (
                        <Paper key={file.id} sx={{ marginTop: '20px' }}>
                            <Box sx={{ display: 'flex', gap: '20px', padding: '20px' }}>
                                <Box sx={{ width: '27%', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <Box>
                                        <img src={Excelimg} alt="Excel" style={{ width: '50px', height: '50px' }} />
                                    </Box>
                                    <Box>
                                        <Typography sx={{ fontSize: "14px", fontWeight: "600", }} variant="subtitle1" gutterBottom>{file.file_name}</Typography>
                                        <Typography sx={{ color: "#00000080", fontSize: "12px", fontWeight: "600" }} variant="h5">{file.file_size}</Typography>
                                    </Box>
                                </Box>
                                <Box sx={{ width: '15%' }}>
                                    <Typography sx={{ color: "#00000080", fontSize: "12px", fontWeight: "600" }} variant="subtitle1" gutterBottom>Year</Typography>
                                    <Typography sx={{ fontSize: "14px", fontWeight: "600", }} variant="h5">{file.year}</Typography>
                                </Box>
                                <Box sx={{ width: '15%' }}>
                                    <Typography sx={{ color: "#00000080", fontSize: "12px", fontWeight: "600" }} variant="subtitle1" gutterBottom>Function L 1</Typography>
                                    <Typography sx={{ fontSize: "14px", fontWeight: "600", }} variant="h5">{file.half_year}</Typography>
                                </Box>
                                <Box sx={{ width: '15%' }}>
                                    <Typography sx={{ color: "#00000080", fontSize: "12px", fontWeight: "600" }} variant="subtitle1" gutterBottom>Update date</Typography>
                                    <Typography sx={{ fontSize: "14px", fontWeight: "600", }} variant="h5">{new Date(file.created_at).toISOString().split('T')[0]}</Typography>
                                </Box>
                                <Box sx={{ width: '20%', display: 'flex', justifyContent: 'right', alignItems: 'center' }}>
                                    <IconButton
                                        size="small"
                                        sx={{ marginRight: '10px' }}
                                        onClick={() => {
                                            handleClickOpen(file.id);
                                        }}
                                    >
                                        <img src={Trash} alt="Trash Icon" />
                                    </IconButton>

                                    <Button
                                        sx={{ backgroundColor: '#000', color: '#fff', textTransform: 'none', fontWeight: '600', fontFamily: 'Avantt', width: "60%", '&:hover': { backgroundColor: '#000' } }}
                                        onClick={() => handleOpenUpdatePopup(file)}
                                    >
                                        Update
                                    </Button>
                                </Box>
                            </Box>
                        </Paper>
                    ))
                ) : (
                    <Paper sx={{ marginTop: '20px', padding: '20px', textAlign: 'center' }}>
                        <Typography variant="h6" sx={{ color: '#222' }}>
                            No file found for the selected year and half-yearly.
                        </Typography>
                    </Paper>
                )
            )}


            <DeleteConfirmationDialog
                open={open}
                handleClose={handleClose}
                handleDelete={handleDelete}
                row={fileData.find((item) => item.id === deletingId)}
                loading={isLoading}
            />
        </>
    )
}

export default UploadResult
